import React, { PureComponent } from 'react';

export default class ModalDefault extends PureComponent {
    static defaultProps = {
        type: 'default',
        size: 'normal'
    }

    render() {
        return (
            <div className={`modal modal-${this.props.type} modal-${this.props.size}`}>
                {
                    this.props.close ? (
                        <span onClick={this.props.close} className="modal-close btn btn-close">
                            Close <i className="ion ion-close-round" />
                        </span>
                    ) : null
                }

                <div className="modal-main">
                    <div className="modal-inner">
                        <div className="modal-header fluid transparent">
                            <h1 className="text-center">
                                { this.props.title }
                            </h1>
                        </div>

                        <div className="modal-body">
                            <div className="article">
                                { this.props.content }
                            </div>
                        </div>

                        <div className="modal-footer">
                            { this.props.actions }
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
